import React, { FunctionComponent, useEffect } from 'react'
import { Heading, Icon, Modal, Text } from '@afterpaytouch/core'
import { useCheckoutSizes } from '../../utils/responsive'
import { useTranslation } from 'next-i18next'
import styles from './style.module.css'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'
import { CloseCheckout } from '../CloseCheckout'

interface EfaRobocallModalProps {
  isError?: boolean
}

export const EfaRobocallModal: FunctionComponent<EfaRobocallModalProps> = ({ isError = false }) => {
  const { headingSize } = useCheckoutSizes()
  const { t } = useTranslation()
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const showModal = isError
  const testNameSpace = 'efa-robocall'

  useEffect(() => {
    logEvent(TrackingEvent.VIEWED_CL_EFA_ROBOCALL_MODAL)
  }, [])

  return (
    <Modal show={showModal} showCloseButton={false} testNameSpace={testNameSpace}>
      <div className={styles.container}>
        <div className={styles.informationPoint}>
          <div className={styles.informationPointIcon}>
            <Icon.NewByronPhoneGeneral size='Large' />
          </div>
        </div>

        <Modal.Header>
          <Heading size={headingSize}>{t('consumerLending:efaRobocallModal.title')}</Heading>
        </Modal.Header>

        <Modal.Content>
          <div className={styles.modalText}>
            <Text size={'M'}>{t('consumerLending:efaRobocallModal.message1')}</Text>
            <div style={{ height: '30px' }}></div>
            <Text size={'M'}>{t('consumerLending:efaRobocallModal.message2')}</Text>
          </div>
          <CloseCheckout
            kind='Secondary'
            padding='Fluid'
            size='Large'
            testNameSpace={testNameSpace}
            onClick={() => logEvent(TrackingEvent.PRESSED_EFA_ROBOCALL_RETURN_TO_MERCHANT_BUTTON)}
          >
            {t('consumerLending:efaRobocallModal.returnToMerchantButton')}
          </CloseCheckout>
        </Modal.Content>
      </div>
    </Modal>
  )
}
